import React, { memo } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { CloseButton } from "react-bootstrap";
import { sidebarConstants } from "../../constants/sidebar.constants";
import useSubscriptionPanelHook from "./useSubscriptionPanelHook";

const SubscriptionPanel = ({
  ...props
}) => {
  const { selected_tab, subscription_ping } = useSelector(
    (state) => ({
      selected_tab: state.sidebar.selected_tab,
      subscription_ping: state.subscription_ping.subscription_ping
    }),
    shallowEqual
  );

  const isSharedOrBusiness = selected_tab === sidebarConstants.DEFAULT_MODES[1] || selected_tab === sidebarConstants.DEFAULT_MODES[2];
  const { display_text, 
          isEndedSubscription, 
          is_hidden, 
          handleCloseSubscriptionPanel
        } = useSubscriptionPanelHook();

  // Do not render if:
  // - there is no text to show
  // - user is currently on the notification tab
  if (!isSharedOrBusiness || is_hidden === true) {
    return null;
  }

  const panelClassName = isEndedSubscription
    ? "subscription-panel--ended"
    : "subscription-panel--ongoing";

  return (
    <div
      className={`subscription-panel d-flex justify-content-between ${panelClassName}`}
    >
      <span>{display_text}</span>

      {!isEndedSubscription && (
        <CloseButton
          variant="white"
          className="opacity-100"
          onClick={handleCloseSubscriptionPanel}
        />
      )}
    </div>
  );
};

export default memo(SubscriptionPanel);